import Slider from "react-slick";
import {
  NextArrow,
  PrevArrow,
} from "../../components/SlickButtons/SlickButtons";
import { Link } from "react-router-dom";
import "./NewReleases.css";
import CardSkeleton from "../../components/Skeleton/CardSkeleton";
import useDevice from "../../hooks/useDevice";
import { useGetNewReleases } from "../../hooks/useGetNewReleases";

function NewReleases() {
  const { isMobile, isTablet } = useDevice();

  const { data: newReleases, isLoading } = useGetNewReleases();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 2 : isTablet ? 4 : 8,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <section className="NewReleases">
      <div className="section-title">
        <h3>New Releases</h3>
      </div>

      <Slider {...settings}>
        {isLoading
          ? Array.from({ length: 8 }).map((_, index) => (
              <CardSkeleton
                key={index}
                width={"95%"}
                height={isTablet ? "312px" : "230px"}
              />
            ))
          : newReleases?.map((product) => {
              return (
                <Link
                  to={`product/${product.slug.toLowerCase()}`}
                  className={`product ${product.slug}`}
                  key={product.slug}
                >
                  <img src={product.images[0].src} alt={product.name} />
                  <p className="product-card-name">{product.name}</p>
                </Link>
              );
            })}
      </Slider>
    </section>
  );
}

export default NewReleases;
